import examDelegate from '@/delegate/examDelegate'
import soundDelegate from '@/delegate/soundDelegate'
import mainDelegate from '@/delegate/mainDelegate'
import Placard from '@/components/Placard'
const ANSWER_WAIT_TIME = process.env.ANSWER_WAIT_TIME
export default {
    mixins: [mainDelegate, examDelegate, soundDelegate],
    data() {
        return {
            ans: '',
            selIndex: -1,
            isX: false
        }
    },
    components: {
        Placard
    },
    methods: {
        sel({ item, index }) {
            if (this.selIndex !== -1) return
            this.selIndex = index
            item.IsSelected = true
            if (item.IsSelected && item.IsAnswer) {
                this.ans = 'o'
                this.addoNum(1) //答對計分
            } else {
                this.ans = 'x'
                this.isX = true
            }
            this.$nextTick(() => {
                this.ans = ''
            })
            this.wordSound.loadUrlList()
        },
        playVocabulary() {
            this.wordSound.autoPlay(this.vocabularyModel.AudioFileName)
        },
        playOption(item) {
            this.wordSound.autoPlay(item.AudioFileName)
            // if (item.AudioFileName) {
            //     new Audio(item.AudioFileName).play()
            // } else {
            //     alert('沒有音效')
            // }
        }
    },
    watch: {
        ans(val) {
            if (val !== '') {
                this.$emit('end') //答題計時
                this.playSound(val)
                setTimeout(() => {
                    this.$emit('ans', val === 'x' ? true : false)
                    this.ans = ''
                    this.selIndex = -1
                    this.isX = false
                }, ANSWER_WAIT_TIME)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/exam/examMixins.js